import React, { useCallback, useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Input,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from "reactstrap";

import { Swiper, SwiperSlide } from "swiper/react";
import keepaImg from "../../assets/images/brands/keepa.png";
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { updateProduct as onUpdateProduct } from "../../slices/thunks";
import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import SwiperCore from "swiper";

import { Link } from "react-router-dom";
import moment from "moment";
import SalesChannels from "../../Components/Common/SalesChannels";
import { useDispatch } from "react-redux";
import ProductImageManager from "./ProductImageManager";
import ProductsUsersModal from "../../Components/Common/ProductsUsersModal";

SwiperCore.use([FreeMode, Navigation, Thumbs]);

/*
{
            "pro_id": 3009,
            "pro_imp_id": 0,
            "pro_sup_id": 69,
            "pro_productID": null,
            "pro_name": "RED HEART Super Saver 3-Pack yarn, ARAN 3 Pack",
            "pro_description": "<p>100% AcrylicSuper Saver yarn has been a favorite among knitters and crocheters for over 30 yearsRed Heart Super Saver yarn is durable and will stand the test of time, wash after washAvailable for 5-mm knitting needle and 5.5-mm crochet hookMachine wash cold, tumble dry low</p>",
            "pro_slug": "red-heart-super-saver-3-pack-yarn-aran-3-pack-1",
            "pro_warehouseCost": 2.5,
            "pro_SKU": "CZY-6717",
            "pro_UPCType": "gtin_12",
            "pro_UPCCode": "073650846427",
            "pro_ASIN": "B07N6WF72F",
            "pro_location": "",
            "pro_imageURLs": "7ddffb33-10d8-9e7d-eeac-ac6a42806211.jpg",
            "pro_shipping": false,
            "pro_price": 18.24,
            "pro_compareAtPrice": 0,
            "pro_costPerItem": 16.17,
            "pro_msrp": "0.00",
            "pro_amazonSellingPrice": 36.42,
            "pro_margin": 3.5,
            "pro_stripeFee": 0,
            "pro_profit": 0.57,
            "pro_shippingCost": 1.5,
            "pro_shippingFee": 0,
            "pro_shippingWeight": 1.37,
            "pro_shippingWeightUnit": "lb",
            "pro_dimLength": 11.65,
            "pro_dimWidth": 9.17,
            "pro_dimHeight": 3.82,
            "pro_dimUnit": "inches",
            "pro_packQuantity": 3,
            "pro_isPack": true,
            "pro_invoiceRequired": false,
            "pro_inStock": false,
            "pro_totalStockQuantity": 10,
            "pro_remainingStockQuantity": 10,
            "pro_poorPerformance": false,
            "pro_batchOrderLimit": 1,
            "pro_customerMinOQ": 10,
            "pro_customerMaxOQ": 10,
            "pro_supplierMinOQ": 0,
            "pro_supplierMaxOQ": 0,
            "pro_status": 0,
            "pro_viewed": 0,
            "pro_dateAdded": "2025-02-13T21:01:47",
            "pro_lastModifiedDate": "2025-02-19T21:33:20",
            "pro_brand": "UPDATE_BRAND",
            "pro_cat_id": 5596,
            "pro_categoryName": "Miscellaneous",
            "pro_continueSelling": null,
            "pro_optionName": null,
            "pro_optionValue": null,
            "pro_automateOrder": null,
            "pro_url": "https://www.amazon.com/dp/B07N6WF72F",
            "pro_userSpecified": false,
            "pro_extendedLeadTime": "",
            "pro_importantNotes": "",
            "pro_salesChannel": 0,
            "pro_ebayAllowed": true,
            "pro_dateDeleted": null
        }
            */
const ProductReview = (props) => {
  return (
    <React.Fragment>
      <li className="py-2">
        <div className="border border-dashed rounded p-3">
          <div className="d-flex align-items-start mb-3">
            <div className="hstack gap-3">
              <div className="badge rounded-pill bg-success mb-0">
                <i className="mdi mdi-star"></i> {props.product.pro_status}
              </div>
              <div className="vr"></div>
              <div className="flex-grow-1">
                <p className="text-muted mb-0">{props.product.pro_name}</p>
              </div>
            </div>
          </div>
          {props.product?.pro_imageURLs && (
            <React.Fragment>
              <div className="d-flex flex-grow-1 gap-2 mb-3">
                {props.product?.pro_imageURLs.split(",").map((subItem, key) => (
                  <React.Fragment key={key}>
                    <Link to="#" className="d-block">
                      <img
                        src={`${process.env.REACT_APP_THUMBS_URL}/products/${subItem}`}
                        alt=""
                        className="avatar-sm rounded object-fit-cover"
                      />
                    </Link>
                  </React.Fragment>
                ))}
              </div>
            </React.Fragment>
          )}

          <div className="d-flex align-items-end">
            <div className="flex-grow-1">
              <h5 className="fs-14 mb-0">{props.product.pro_name}</h5>
            </div>

            <div className="flex-shrink-0">
              <p className="text-muted fs-13 mb-0">
                {props.product.pro_lastModifiedDate}
              </p>
            </div>
          </div>
        </div>
      </li>
    </React.Fragment>
  );
};

const openKeepaPopup = (url) => {
  const width = 1000;
  const height = 500;
  const left = Math.round((window.screen.width - width) / 2);
  const top = Math.round((window.screen.height - height) / 3);
  window.open(url, "keepa", `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`);
};

const keepaFinderUrl = "https://keepa.com/#!finder";

const isKeepaUrl = (url) => {
  try {
    const { hostname, protocol } = new URL(url);
    return ["http:", "https:"].includes(protocol) &&
      (hostname === "keepa.com" || hostname.endsWith(".keepa.com"));
  } catch {
    return false;
  }
};

const KeepaLink = ({ params }) => {
  const [showPreview, setShowPreview] = useState(false);
  const asin = params?.pro_ASIN;
  const isKeepaLink = isKeepaUrl(params?.pro_link);
  const keepaDestination = isKeepaLink ? params.pro_link : keepaFinderUrl;
  const previewUrl = asin && isKeepaLink
    ? `https://graph.keepa.com/pricehistory.png?domain=1&asin=${asin}`
    : null;

  return (
    <center style={{ position: "relative", display: "inline-block" }}>
      <img
        alt="keepa link logo"
        src={keepaImg}
        className="logo"
        style={{ cursor: "pointer" }}
        onClick={() => openKeepaPopup(keepaDestination)}
        onMouseEnter={() => previewUrl && setShowPreview(true)}
        onMouseLeave={() => setShowPreview(false)}
      />
      {showPreview && previewUrl && (
        <div
          style={{
            position: "absolute",
            top: "calc(100% + 8px)",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            background: "#fff",
            border: "1px solid #ccc",
            borderRadius: "6px",
            padding: "4px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            pointerEvents: "none",
          }}
        >
          <img
            src={previewUrl}
            alt="Keepa price history"
            referrerPolicy="no-referrer"
            style={{ width: "400px", height: "auto", display: "block" }}
          />
        </div>
      )}
    </center>
  );
};

const keepaLinkRenderer = (params) => <KeepaLink params={params} />;

const PricingWidgetList = (props) => {
  return (
    <React.Fragment>
      <Col xxl={3} xl={3} lg={3} md={4} sm={6} xs={12}>
        <div
          className={`p-2 border border-${props.border ? props.border : "dashed"
            } rounded mb-1`}
          style={{ height: "80px", width: "100%" }}
        >
          <div className="d-flex align-items-center">
            <div className="avatar-sm me-2">
              <div className={`avatar-title rounded bg-transparent fs-24`}>
                <i
                  className={`${props.pricingDetails.icon} text-${props.pricingDetails.iconColor != null
                      ? props.pricingDetails.iconColor
                      : "success"
                    }`}
                ></i>
              </div>
            </div>
            <div className="flex-grow-1">
              <p className="text-muted mb-1">
                {props.pricingDetails.label}{" "}
                {props.pricingDetails.labelDetail ? ":" : ""}
              </p>
              <h5 className="mb-0">{props.pricingDetails.labelDetail}</h5>
            </div>
          </div>
        </div>
      </Col>
    </React.Fragment>
  );
};

function ProductDetail(props) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [productImage, setProductImage] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [customActiveTab, setcustomActiveTab] = useState("1");
  const [extendedLeadTime, setExtendedLeadTime] = useState(
    props.product?.pro_extendedLeadTime || 0
  );
  const [MAP, setMAP] = useState(props.product?.pro_MAP || 0);
  const [notes, setNotes] = useState(props.product?.pro_importantNotes || "");
  const [isHot, setIsHot] = useState(props.product?.pro_isHot);
  const [isActive, setIsActive] = useState(props.product?.pro_status);
  const [isVisible, setIsVisible] = useState(props.product?.pro_visible);
  const [moq, setMoq] = useState(props.product?.pro_supplierMinOQ || 0);
  const [totalStock, setTotalStock] = useState(
    props.product?.pro_totalStockQuantity || 0
  );
  const [numONBCM, setNumONBCM] = useState(props.product?.pro_numONBCM || 0);
  const [isImageManagerOpen, setIsImageManagerOpen] = useState(false);
  const [imageManagerView, setImageManagerView] = useState("grid");
  const [showProductsUsersModal, setShowProductsUsersModal] = useState(false);
  let { product } = props;
  const dispatch = useDispatch();

  const save = () => {
    if (isEdit) {
      const data = { ...product };

      data.pro_extendedLeadTime = extendedLeadTime.toString();
      data.pro_MAP = Number(MAP);
      data.pro_importantNotes = notes;
      data.pro_isHot = isHot;
      data.pro_supplierMinOQ = moq;
      data.pro_totalStockQuantity = totalStock;
      data.pro_numONBCM = Math.min(Math.max(Number(numONBCM), 0), 7);
      data.pro_status = isActive ? 0 : 1;
      data.pro_visible = isVisible;
      dispatch(onUpdateProduct(data));
    }
  };

  const saveImage = () => {
    const data = { ...product };

    data.pro_imageURLs = productImage;
    dispatch(onUpdateProduct(data));
  };

  const toggleImageManager = () => {
    setIsImageManagerOpen(!isImageManagerOpen);
  };

  const handleUpdateImages = (newImages) => {
    const data = { ...product };
    // Join array back to comma-separated string if that's the format
    // Based on existing code: product?.pro_imageURLs.split(",")
    data.pro_imageURLs = newImages.join(",");
    dispatch(onUpdateProduct(data));
  };

  useEffect(() => {
    return () => {
      setThumbsSwiper(null);
    };
  }, [props]);

  useEffect(() => {
    return () => {
      setIsEdit(false);
    };
  }, []);

  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  const toggle = useCallback(() => {
    if (props.show) {
      props.onClose();
    }
  }, [props.show]);

  useEffect(() => {
    setIsEdit(false);
    setExtendedLeadTime(product?.pro_extendedLeadTime || 0);
    setMAP(product?.pro_MAP || 0);
    setNotes(product?.pro_importantNotes || "");
    setIsHot(product?.pro_isHot);
    setMoq(product?.pro_supplierMinOQ || 0);
    setTotalStock(product?.pro_totalStockQuantity || 0);
    setNumONBCM(product?.pro_numONBCM || 0);
    setIsActive(product?.pro_status == 0 ? true : false);
    setIsVisible(product?.pro_visible);
  }, [product]);

  return (
    <Modal
      Modal
      isOpen={props.show}
      modalClassName="zoomIn"
      centered
      tabIndex="-1"
      fullscreen
    >
      <ModalHeader toggle={toggle} className="p-3 bg-primary-subtle">
        <Row className="align-items-center gy-3">
          <div className="col-sm">
            <h5 className="card-title mb-0">Product Detail</h5>
          </div>
        </Row>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <Row className="gx-lg-5">
                  {product?.pro_imageURLs && product?.pro_imageURLs !== "" ? (
                    <Col xl={4} md={8} className="mx-auto">
                      <div className="product-img-slider sticky-side-div">
                        <Swiper
                          navigation={true}
                          thumbs={{ swiper: thumbsSwiper }}
                          className="swiper product-thumbnail-slider p-2 rounded bg-light"
                        >
                          <div className="swiper-wrapper">
                            {product?.pro_imageURLs
                              .split(",")
                              .map((subItem, key) => (
                                <SwiperSlide key={key}>
                                  <img
                                    src={subItem.startsWith("http") ? subItem : `${process.env.REACT_APP_THUMBS_URL}/products/${subItem}`}
                                    alt=""
                                    style={{
                                      height: "400px",
                                      width: "100%",
                                      objectFit: "contain",
                                    }}
                                    className="img-fluid d-block"
                                  />
                                </SwiperSlide>
                              ))}
                          </div>
                        </Swiper>

                        <div className="product-nav-slider mt-2">
                          <Swiper
                            onSwiper={setThumbsSwiper}
                            slidesPerView={4}
                            freeMode={true}
                            watchSlidesProgress={true}
                            spaceBetween={10}
                            className="swiper product-nav-slider mt-2 overflow-hidden"
                          >
                            <div className="swiper-wrapper">
                              {product?.pro_imageURLs
                                .split(",")
                                .map((subItem, key) => (
                                  <SwiperSlide key={key}>
                                    <div className="nav-slide-item">
                                      <img
                                        src={subItem.startsWith("http") ? subItem : `${process.env.REACT_APP_THUMBS_URL}/products/${subItem}`}
                                        alt=""
                                        className="img-fluid d-block"
                                        style={{
                                          height: "80px",
                                          width: "80px",
                                          objectFit: "contain",
                                        }}
                                      />
                                    </div>
                                  </SwiperSlide>
                                ))}
                            </div>
                          </Swiper>
                        </div>
                        <div className="text-center mt-3">
                          <Button
                            color="primary"
                            outline
                            onClick={() => {
                              setImageManagerView("grid");
                              toggleImageManager();
                            }}
                          >
                            <i className="ri-image-edit-line me-1"></i> Edit Images
                          </Button>
                        </div>
                      </div>
                    </Col>
                  ) : (
                    <Col xl={4} md={8} className="mx-auto">
                      <div
                        className="ratio ratio-1x1 border border-dashed rounded d-flex align-items-center justify-content-center cursor-pointer hover-bg-light"
                        onClick={() => {
                          setImageManagerView("add");
                          toggleImageManager();
                        }}
                        style={{ cursor: "pointer", maxWidth: "400px", margin: "0 auto" }}
                      >
                        <div className="text-center">
                          <i className="ri-add-line fs-1"></i>
                          <p className="mb-0">Add Image</p>
                        </div>
                      </div>
                    </Col>
                  )}

                  <Col xl={8}>
                    <div className="mt-xl-0 mt-5">
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <Link
                            to={product?.pro_url}
                            className="text-body"
                            target="_blank"
                          >
                            {" "}
                            <h4>{product?.pro_name}</h4>
                          </Link>
                          <div className="hstack gap-3 flex-wrap">
                            {keepaLinkRenderer(product)}
                            <span
                              className={
                                product?.pro_status == 0
                                  ? "badge text-dark rounded-pill bg-success"
                                  : "badge text-dark rounded-pill bg-danger"
                              }
                            >
                              {product?.pro_status == 0 ? "active" : "inactive"}
                            </span>
                            {product?.pro_packQuantity > 1 && (
                              <span className="badge rounded-pill bg-primary text-dark">
                                pack of {product?.pro_packQuantity}
                              </span>
                            )}
                            <div className="vr"></div>
                            <div className="text-muted">
                              <span className="text-body fw-medium">
                                <b>UPC:</b>{" "}
                                {product?.pro_UPCCode
                                  ? product?.pro_UPCCode
                                  : "N/A"}
                                {product?.pro_ASIN && (
                                  <span>
                                    {" / "}
                                    <b>ASIN:</b> {product?.pro_ASIN}
                                  </span>
                                )}
                                {product?.pro_SKU && (
                                  <span>
                                    {" / "}
                                    <b>SKU:</b> {product?.pro_SKU}
                                  </span>
                                )}
                              </span>
                            </div>
                            <div className="text-muted">
                              Vetted Channel(s):{" "}
                              <SalesChannels
                                channel={product?.pro_salesChannel}
                              />
                            </div>
                            <div className="text-muted">
                              Published :{" "}
                              <span className="text-body fw-medium">
                                {moment(product?.pro_dateAdded).format(
                                  "MM/DD/YYYY, h:mm a"
                                )}
                              </span>
                            </div>
                            <div className="text-muted">
                              Last Updated :{" "}
                              <span className="text-body fw-medium">
                                {moment(product?.pro_lastModifiedDate).format(
                                  "MM/DD/YYYY, h:mm a"
                                )}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="flex-shrink-0">
                          <div className="d-flex gap-2">
                            <Button
                              color="info"
                              outline
                              onClick={() => setShowProductsUsersModal(true)}
                              title="Manage product users"
                            >
                              <i className="ri-user-settings-line me-1"></i>
                              Manage Users
                            </Button>
                            <Button
                              onClick={() => {
                                save();
                                setIsEdit(!isEdit);
                              }}
                              id="TooltipTop"
                              className={`btn ${isEdit ? "btn-success" : "btn-primary"
                                }`}
                            >
                              {isEdit ? " Save " : " Edit "}
                              {isEdit ? (
                                <i className="ri-check-fill align-bottom"></i>
                              ) : (
                                <i className="ri-pencil-fill align-bottom"></i>
                              )}
                            </Button>
                          </div>
                        </div>
                      </div>

                      <Row className="mt-4 ">
                        <PricingWidgetList
                          pricingDetails={{
                            icon: "ri-money-dollar-circle-fill",
                            label: "Price",
                            labelDetail: ` ${new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                            }).format(product?.pro_price)}`,
                          }}
                        />
                        <PricingWidgetList
                          pricingDetails={{
                            icon: "ri-money-dollar-circle-fill",
                            label: "Cost per item",
                            labelDetail: ` ${new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                            }).format(product?.pro_costPerItem)}`,
                          }}
                        />
                        <PricingWidgetList
                          pricingDetails={{
                            icon: "ri-money-dollar-circle-fill",
                            label: "Amazon selling price",
                            labelDetail: `${new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                            }).format(product?.pro_amazonSellPrice)}`,
                          }}
                        />
                        <PricingWidgetList
                          pricingDetails={{
                            icon: "ri-money-dollar-circle-fill",
                            label: "Shipping Cost",
                            labelDetail: `${new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                            }).format(product?.pro_shippingCost)}`,
                          }}
                        />
                        <PricingWidgetList
                          pricingDetails={{
                            icon: "ri-money-dollar-circle-fill",
                            label: "Stripe Fee",
                            labelDetail: `${new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                            }).format(product?.pro_stripeFee)}`,
                          }}
                        />
                        <PricingWidgetList
                          pricingDetails={{
                            icon: "ri-percent-line",
                            label: "Stripe surcharge",
                            labelDetail: `${new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                            }).format(product?.pro_stripeSurcharge)}`,
                          }}
                        />
                        <PricingWidgetList
                          pricingDetails={{
                            icon: "ri-percent-line",
                            label: "Markup",
                            labelDetail: `${product?.pro_markUp} %`,
                          }}
                        />
                        <PricingWidgetList
                          pricingDetails={{
                            icon: "ri-money-dollar-circle-fill",
                            label: "Profit",
                            labelDetail: `${new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                            }).format(product?.pro_profit)}`,
                          }}
                        />

                        <PricingWidgetList
                          pricingDetails={{
                            icon: "ri-stack-fill",
                            label: "Available Stock Quantity",
                            labelDetail: `${product?.pro_availableStock}`,
                          }}
                        />
                        {isEdit ? (
                          <PricingWidgetList
                            border="solid"
                            pricingDetails={{
                              icon: "ri-time-fill",
                              label: "Total Stock Quantity",
                              labelDetail: (
                                <Input
                                  type="number"
                                  value={totalStock}
                                  onChange={(e) =>
                                    setTotalStock(e.target.value)
                                  }
                                />
                              ),
                            }}
                          />
                        ) : (
                          <PricingWidgetList
                            pricingDetails={{
                              icon: "ri-stack-fill",
                              label: "Total Stock Quantity",
                              labelDetail: `${product?.pro_totalStockQuantity}`,
                            }}
                          />
                        )}

                        {isEdit ? (
                          <PricingWidgetList
                            border="solid"
                            pricingDetails={{
                              icon: "ri-time-fill",
                              label: "MOQ",
                              labelDetail: (
                                <Input
                                  type="number"
                                  value={moq}
                                  onChange={(e) => setMoq(e.target.value)}
                                />
                              ),
                            }}
                          />
                        ) : (
                          <PricingWidgetList
                            pricingDetails={{
                              icon: "ri-stack-fill",
                              label: "MOQ",
                              labelDetail: `${product?.pro_supplierMinOQ || 0
                                } `,
                            }}
                          />
                        )}
                        {isEdit ? (
                          <PricingWidgetList
                            border="solid"
                            pricingDetails={{
                              icon: "ri-time-fill",
                              label: "Extended Lead Time",
                              iconColor: "danger",
                              labelDetail: (
                                <Input
                                  type="number"
                                  value={extendedLeadTime}
                                  onChange={(e) =>
                                    setExtendedLeadTime(e.target.value)
                                  }
                                />
                              ),
                            }}
                          />
                        ) : (
                          <PricingWidgetList
                            pricingDetails={{
                              icon: "ri-time-fill",
                              label: "Extended Lead Time",
                              iconColor: "danger",
                              labelDetail: `${product?.pro_extendedLeadTime || 0
                                } days`,
                            }}
                          />
                        )}
                        {isEdit ? (
                          <PricingWidgetList
                            border="solid"
                            pricingDetails={{
                              icon: "ri-price-tag-fill",
                              label: "MAP",
                              iconColor: "danger",
                              labelDetail: (
                                <Input
                                  type="number"
                                  value={MAP}
                                  onChange={(e) => {
                                    setMAP(e.target.value);
                                  }}
                                />
                              ),
                            }}
                          />
                        ) : (
                          <PricingWidgetList
                            pricingDetails={{
                              icon: "ri-price-tag-fill",
                              label: "MAP",
                              iconColor: "danger",
                              labelDetail: `${new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                              }).format(product?.pro_MAP || 0)}`,
                            }}
                          />
                        )}

                        {isEdit ? (
                          <PricingWidgetList
                            border="solid"
                            pricingDetails={{
                              icon: "ri-group-fill",
                              label: (
                                <span>
                                  New BC members{" "}
                                  <i
                                    className="ri-information-line"
                                    title="(manually round up/down Max 7)"
                                    style={{ cursor: "help" }}
                                  />
                                </span>
                              ),
                              iconColor: "info",
                              labelDetail: (
                                <Input
                                  type="number"
                                  min="0"
                                  max="7"
                                  value={numONBCM}
                                  onChange={(e) => {
                                    const value = Math.min(Math.max(Number(e.target.value) || 0, 0), 7);
                                    setNumONBCM(value);
                                  }}
                                />
                              ),
                            }}
                          />
                        ) : (
                          <PricingWidgetList
                            pricingDetails={{
                              icon: "ri-group-fill",
                              label: (
                                <span>
                                  New BC members{" "}
                                  <i
                                    className="ri-information-line"
                                    title="(manually round up/down Max 7)"
                                    style={{ cursor: "help" }}
                                  />
                                </span>
                              ),
                              iconColor: "info",
                              labelDetail: `${product?.pro_numONBCM || 0}`,
                            }}
                          />
                        )}

                        <PricingWidgetList
                          border={isEdit ? "solid" : "dashed"}
                          pricingDetails={{
                            icon: "ri-fire-fill",
                            label: "Force to hot list",
                            labelDetail: (
                              <div className="form-check form-switch">
                                <Input
                                  disabled={!isEdit}
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={isHot}
                                  onChange={(e) => {
                                    setIsHot(e.target.checked);
                                  }}
                                />
                              </div>
                            ),
                          }}
                        />

                        <PricingWidgetList
                          border={isEdit ? "solid" : "dashed"}
                          pricingDetails={{
                            icon: "ri-checkbox-circle-fill",
                            label: "This product is active",
                            iconColor: isActive ? "success" : "danger",
                            labelDetail: (
                              <div className="form-check form-switch">
                                <Input
                                  disabled={!isEdit}
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={isActive}
                                  onChange={(e) => {
                                    setIsActive(e.target.checked);
                                  }}
                                />
                              </div>
                            ),
                          }}
                        />

                        <PricingWidgetList
                          border={isEdit ? "solid" : "dashed"}
                          pricingDetails={{
                            icon: isVisible ? "ri-checkbox-circle-fill" : "ri-close-circle-fill",
                            label: "This product is visible",
                            iconColor: isVisible ? "success" : "danger",
                            labelDetail: (
                              <div className="form-check form-switch">
                                <Input
                                  disabled={!isEdit}
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={isVisible}
                                  onChange={(e) => {
                                    setIsVisible(e.target.checked);
                                  }}
                                />
                              </div>
                            ),
                          }}
                        />
                      </Row>

                      <div className="product-content mt-4">
                        <span className="text-danger fw-medium">
                          Important Notes:{" "}
                          {isEdit ? (
                            <Input
                              type="textarea"
                              value={notes}
                              onChange={(e) => setNotes(e.target.value)}
                            />
                          ) : (
                            product?.pro_importantNotes
                          )}
                        </span>
                      </div>
                      <div className="product-content mt-5">
                        <h5 className="fs-14 mb-3">Specification :</h5>
                        <div className="table-responsive">
                          <table className="table mb-0">
                            <tbody>
                              <tr>
                                <th scope="row" style={{ width: "200px" }}>
                                  Category
                                </th>
                                <td>{product?.pro_categoryName}</td>
                              </tr>
                              <tr>
                                <th scope="row">Brand</th>
                                <td>{product?.pro_brand}</td>
                              </tr>
                              <tr>
                                <th scope="row">Color</th>
                                <td>Blue</td>
                              </tr>
                              <tr>
                                <th scope="row">Weight</th>
                                <td>
                                  {product?.pro_shippingWeight}{" "}
                                  {product?.pro_shippingWeightUnit}
                                </td>
                              </tr>
                              <tr>
                                <th scope="row">Dimensions</th>
                                <td>
                                  {product?.pro_dimLength} x{" "}
                                  {product?.pro_dimWidth} x{" "}
                                  {product?.pro_dimHeight}{" "}
                                  {product?.pro_dimUnit}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </ModalBody>
      <ProductImageManager
        isOpen={isImageManagerOpen}
        toggle={toggleImageManager}
        images={product?.pro_imageURLs ? product.pro_imageURLs.split(",") : []}
        onUpdateImages={handleUpdateImages}
        productId={product?.pro_id}
        initialView={imageManagerView}
      />
      <ProductsUsersModal
        show={showProductsUsersModal}
        productId={product?.pro_id}
        userType={0}
        onCloseClick={() => setShowProductsUsersModal(false)}
        onSaveSuccess={() => {
          // Optionally refresh product data if needed
        }}
      />
    </Modal>
  );
}

export default ProductDetail;
